import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
    setMobileSearchOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-600"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              西瓜视频<span className="text-primary-500">免费</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={submitSearch} className="hidden md:flex items-center">
              <div className="flex items-center rounded-md border border-background-300 bg-background-100 pl-3 focus-within:border-primary-400">
                <i className="ri-search-line text-sm text-foreground-400" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视、综艺、演员"
                  className="w-44 lg:w-56 bg-transparent px-2 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
                <button
                  type="submit"
                  className="m-0.5 whitespace-nowrap rounded bg-primary-500 px-3 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  搜索
                </button>
              </div>
            </form>

            <button
              type="button"
              aria-label="搜索"
              onClick={() => setMobileSearchOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 md:hidden hover:bg-background-100"
            >
              <i className="ri-search-line text-lg" />
            </button>

            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-700 md:hidden hover:bg-background-100"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {mobileSearchOpen && (
          <form onSubmit={submitSearch} className="pb-3 md:hidden">
            <div className="flex items-center rounded-md border border-background-300 bg-background-100 pl-3 focus-within:border-primary-400">
              <i className="ri-search-line text-sm text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视、综艺、演员"
                className="w-full bg-transparent px-2 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
              <button
                type="submit"
                className="m-0.5 whitespace-nowrap rounded bg-primary-500 px-3 py-1.5 text-sm font-medium text-background-50"
              >
                搜索
              </button>
            </div>
          </form>
        )}

        {menuOpen && (
          <nav className="flex flex-col gap-1 pb-4 md:hidden">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? "bg-primary-50 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}